import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@bleu.builders/ui";
import React from "react";
import {
  Outlet,
  useLoaderData,
  useLocation,
  useParams,
} from "react-router-dom";

import { Link } from "#/components/Link";
import { formatDate } from "#/lib/formatDate";
import { cn } from "#/lib/utils";

import { PlanActions } from "../(components)/PlanActions";
import { Subscription } from "../(components)/subscription";

const paths = ({ organization_id }) => [
  {
    name: "Cobranças",
    path: `/admin/organizations/${organization_id}`,
  },
  {
    name: "Usuários",
    path: `/admin/organizations/${organization_id}/users`,
  },
  {
    name: "Histórico de créditos",
    path: `/admin/organizations/${organization_id}/transactions`,
  },
];

export function OrganizationDetails() {
  const { pathname } = useLocation();
  const { organization_id } = useParams();

  // @ts-ignore-next-line
  const { data } = useLoaderData();

  return (
    <div className="container mx-0 pt-5">
      <div className="flex flex-col gap-5">
        <PlanActions organization={data} />
        <div className="grid grid-cols-10 space-x-5">
          <div className="mb-5 col-span-5">
            <Card className="max-w-none border-2 shadow-sm bg-background">
              <CardHeader className="px-4 py-6">
                <div className="flex items-center gap-4">
                  <img
                    src={
                      data.brand_theme?.logo ||
                      "https://media.istockphoto.com/id/1300845620/pt/vetorial/user-icon-flat-isolated-on-white-background-user-symbol-vector-illustration.jpg?s=612x612&w=0&k=20&c=7TO9d1_F-zi74bCZGEUzpa-nXT1JbcVglYMk_4MSwdg="
                    }
                    className="size-28 object-fill rounded-full border"
                  />
                  <div className="grid">
                    <CardTitle className="text-lg pl-0">{data.name}</CardTitle>
                    <CardDescription className="pl-0 text-base">
                      {data.domain}
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="px-4 py-6 w-full">
                <div className="grid gap-2">
                  <div className="flex items-center gap-2">
                    <div className="text-base font-semibold">
                      Email de cobrança
                    </div>
                    <div className="ml-auto">{data.email}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="text-base font-semibold">Créditos</div>
                    <div className="ml-auto">{data.available_credits}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="text-base font-semibold">Criado em</div>
                    <div className="ml-auto">{formatDate(data.created_at)}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="text-base font-semibold">Cor primária</div>
                    <div className="ml-auto flex items-center gap-2">
                      <span>{data.brand_theme?.primary_color}</span>
                      <div
                        className="size-5 rounded-full"
                        style={{
                          backgroundColor: data.brand_theme?.primary_color,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="col-span-5 flex space-x-2">
            <Subscription organization={data} />
          </div>
        </div>
        <div className="w-full">
          <div className="flex gap-3">
            {paths({ organization_id }).map((item, idx) => (
              <Link
                key={idx}
                to={item.path}
                className={cn(
                  "text-muted-foreground px-2 py-1 text-sm font-medium",
                  {
                    "bg-accent border-2-primary rounded-md text-foreground":
                      pathname === item.path,
                  },
                )}
              >
                {item.name}
              </Link>
            ))}
          </div>
          <div className="mr-5 mt-5">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
